/** The three models the app knows; anything else uploaded shows up too. */
export const KNOWN_MODELS = [
    { key: 'quran-base-q5', name: 'Kur\'anski model (Hifz AI)', hint: 'ggml-quran-base-q5.bin · whisper base, fine-tuned na Kur\'anu' },
    { key: 'quran-base-q5-encoder', name: 'Neural Engine enkoder', hint: 'ggml-quran-base-q5-encoder.mlmodel · CoreML enkoder istog modela' },
    { key: 'hutba-small-q5', name: 'Model za hutbu (offline)', hint: 'ggml-small-q5_1.bin · whisper small, višejezični' },
];

export const getters = {
    byKey: (state) => (key) => state.list.find((m) => m.key === key) ?? null,
    /** Known keys first (in order), then whatever else exists. */
    rows(state) {
        const known = KNOWN_MODELS.map((k) => ({ ...k, ...(state.list.find((m) => m.key === k.key) ?? { missing: true }) }));
        const extra = state.list.filter((m) => !KNOWN_MODELS.some((k) => k.key === m.key));
        return [...known, ...extra];
    },
};
